import PropTypes from 'prop-types';
import React from 'react';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import translate from '../../commonComponents/translate';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import { useSanitize } from '../../services/customHooks';

function Terms(props) {
  const { t, termsAndConditions } = props;
  const terms = useSanitize(termsAndConditions);
  return (
    <Title title={t('landing_termsAndConditions')}>
      <ContentContainer>
        <SubHeader title={t('landing_termsAndConditions')} />
        <div className="m-content">
          <div className="row full-page-container">
            <div
              className="container bg-white pt-2"
              dangerouslySetInnerHTML={{
                __html: terms,
              }}
            />
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

Terms.propTypes = {
  t: PropTypes.func.isRequired,
  termsAndConditions: PropTypes.string.isRequired,
};

export default translate(Terms);
